import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'
import { setFilter } from '@/reducers/realtime/realtimeCoaching/realtimeCoaching.redux'

export const GroupByFilter = () => {
  const dispatch = useDispatch()
  const { filters } = useSelector((state) => state.realtimeCoaching)
  return (
    <FormField>
      <label>Group By</label>
      <Select
        placeholder="placeholder"
        options={[
          { value: 'day', label: 'Day' },
          { value: 'week', label: 'Week' },
          { value: 'month', label: 'Month' },
          { value: 'quarter', label: 'Quarter' },
        ]}
        value={filters.groupBy}
        onChange={({ value }) => {
          dispatch(setFilter({ groupBy: value }))
        }}
        isClearable={false}
      />
    </FormField>
  )
}
